<app-navbar-layout></app-navbar-layout>
<div class="main">
  <router-outlet></router-outlet>
</div>
